import React from 'react';
import { isNil } from 'rambda';
import { Typography } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useStore } from '../../useStore';
import { useOnlineStatus } from '../../../../hooks/useOnlineStatus';
import { FullWidthHeightSpace } from '../../../../components/Space/FullWidthHeightSpace';
import { Floorplan } from '../../../../components/Floorplan/Floorplan';
import { FloorplanMarker } from '../../../../components/Floorplan/Marker';
import { FloorplanStepContent as messages } from './messages';

export const FloorplanStepContent: React.VFC = () => {
  const { isOnline } = useOnlineStatus();
  const { floorplanPosition, locationBuilding, buildingFloor, setFloorplanStepValues, location } = useStore();

  const hasFloorplanValues =
    !isNil(buildingFloor) && ((!isNil(locationBuilding) && locationBuilding !== 'empty') || !isNil(location?.id));

  const handleMarkerDragEnd = (updatedMarker: FloorplanMarker) => {
    setFloorplanStepValues({
      floorplanPosition: {
        lat: updatedMarker.lat,
        lng: updatedMarker.lng,
      },
    });
  };

  const buildingId = locationBuilding === 'empty' ? undefined : locationBuilding;
  const locationId = locationBuilding && locationBuilding !== 'empty' ? undefined : location?.id;

  return (
    <FullWidthHeightSpace>
      {isOnline && hasFloorplanValues ? (
        <Floorplan
          editable
          buildingFloor={buildingFloor}
          buildingId={buildingId}
          locationId={locationId}
          markers={[
            {
              id: 'default',
              lat: floorplanPosition.lat,
              lng: floorplanPosition.lng,
            },
          ]}
          onMarkerDragEnd={handleMarkerDragEnd}
        />
      ) : (
        <div className="text-center">
          <Typography.Title level={5}>
            <div> (⇀‸↼‶) </div>
            <FormattedMessage {...messages.floorplanDoesNotExist} />
          </Typography.Title>
        </div>
      )}
    </FullWidthHeightSpace>
  );
};
